// extracted by mini-css-extract-plugin
module.exports = {"flash":"styles_flash__kpc_B"};